import { Container } from '@bootstrap-styled/v4';
import React from 'react';
import styled from 'styled-components';
import IntroductionTitle from './introduction-title';
import colors from 'shared-components/theme/colors';
import IntroductionDesc from './introduction-desc';
import { baseURL } from 'shared-components/theme/helpers';
import ScrollAnimation from 'react-animate-on-scroll';
import Media from 'shared-components/theme/medias';
const Global = ({ bgImg }) => {
    const logos = [
        `${baseURL}assets/images/geos/pakistan/iso.svg`,
        `${baseURL}assets/images/geos/pakistan/ccpa.svg`,
        `${baseURL}assets/images/geos/pakistan/pci.svg`,
        `${baseURL}assets/images/geos/pakistan/hipaa.svg`,
        `${baseURL}assets/images/geos/pakistan/gdpr.svg`,
    ];
    return (
        <Wrap bgImg={bgImg}>
            <Container>
                <GlobalContainer>
                    <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
                        <IntroductionTitle
                            title={'Secure by Design. Trusted globally.'}
                            textColor={colors.white[100]}
                        />
                    </ScrollAnimation>
                    <LogosWrap>
                        {logos.map((logo, i) => (
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOnce={true}
                                key={i}
                                delay={(i + 1) * 100}>
                                <img src={logo} alt="ibex" loading="lazy" />
                            </ScrollAnimation>
                        ))}
                    </LogosWrap>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        animateOnce={true}
                        delay={150}
                        className="global_para">
                        <IntroductionDesc
                            desc={
                                'Our Pakistan sites operate with strict protocols, monitored environments, and best-in-class data protection.'
                            }
                            textColor={colors.white[100]}
                        />
                    </ScrollAnimation>
                </GlobalContainer>
            </Container>
        </Wrap>
    );
};

export default Global;

const Wrap = styled.section`
    background: ${({ bgImg }) => `url(${bgImg}) no-repeat center top / cover`};
    position: relative;
    z-index: 2;
    ${Media('mobile')} {
        h2 {
            text-align: center;
        }
        img {
            width: 90%;
        }
    }
`;

const GlobalContainer = styled.div`
    border-radius: 10px;
    backdrop-filter: blur(30px) brightness(0.9);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
    padding: 40px 10px;
    margin: 80px 0;
    h2 {
        margin: 0;
    }
    .global_para {
        max-width: 60%;
        width: 100%;
        text-align: center;
        margin: 0;
    }

    ${Media('mobile')} {
        gap: 30px;
        margin: 0;
    }
`;

const LogosWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 900px;
    width: 100%;
    margin: auto;

    ${Media('mobile')} {
        justify-content: center;
        gap: 30px;
    }
`;
